import Component from '../core/Component'
import support from '../utils/BrowserSupport'
import keycode from 'keycode'
import { enableScrolling, disableScrolling } from '../services/Scroll'
import enquire from 'enquire.js'
import { queries } from '../core/config'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active'
}

export default class MobileNav extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            close: null,
            content: null,
            inner: null
        }

        this.enquireHandler = {
            match: () => this.close()
        }
    }

    prepare() {
        this.ref.inner.addEventListener(support.transitionEnd, () => {
            if (!this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            }
        })

        this.element.addEventListener('click', ::this.handleClick)
        enquire.register(queries.largeUp, this.enquireHandler)
    }

    destroy() {
        this.close()
        document.removeEventListener('keydown', this.handleKeydown)
        enquire.unregister(queries.largeUp, this.enquireHandler)
    }

    handleClick(event) {
        if (!this.ref.content.contains(event.target)) {
            event.preventDefault()
            this.close()
        } else if (event.target.closest('a')) {
            this.close()
        }
    }

    handleKeydown = event => {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    close() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }
        this.element.classList.remove(STATES.ACTIVE)
        document.removeEventListener('keydown', this.handleKeydown)
        enableScrolling()
    }

    open() {
        disableScrolling()
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        document.addEventListener('keydown', this.handleKeydown)
    }

}